import { useState } from 'react';
// Link import removed
import { SEO } from '../components/SEO';
import { JobApplicationForm } from '../components/JobApplicationForm';
import { 
  Briefcase, 
  Clock, 
  GraduationCap, 
  Users, 
  Star, 
  Heart,
  ArrowRight,
  X,
  Moon,
  Building2,
  CalendarDays,
  Check,
  MapPin
} from 'lucide-react';

export function Jobs() {
  const [showApplication, setShowApplication] = useState(false);

  const benefits = [
    {
      icon: Briefcase,
      title: 'Attraktive Vergütung',
      description: 'Übertarifliche Bezahlung mit regelmäßigen Gehaltsreviews',
    },
    {
      icon: Clock,
      title: 'Flexible Zeiten',
      description: 'Schichtmodelle, die zu Ihrem Leben passen',
    },
    {
      icon: GraduationCap,
      title: 'Weiterbildung',
      description: 'Zugang zu Schulungen und Zertifizierungen',
    },
    {
      icon: Users,
      title: 'Premium Netzwerk',
      description: 'Arbeit in renommierten Hotels deutschlandweit',
    },
    {
      icon: Star,
      title: 'Karrierechancen',
      description: 'Möglichkeit zur Übernahme bei Partnerhotels',
    },
    {
      icon: Heart,
      title: 'Teamkultur',
      description: 'Wertschätzung und regelmäßige Teamevents',
    },
  ];

  const roles = [
    {
      icon: Moon,
      title: 'Night Auditor',
      description: 'Nächtliche Abrechnung, Gästebetreuung und Systemadministration',
    },
    {
      icon: Building2,
      title: 'Empfangsmitarbeiter',
      description: 'Check-in/out, Reservierungsmanagement und Concierge-Service',
    },
    {
      icon: CalendarDays,
      title: 'Event Support',
      description: 'Professioneller Support für Kongresse und Veranstaltungen',
    },
  ];

  const requirements = [
    'Erfahrung in der Hotellerie oder Gastronomie',
    'Serviceorientierung und professionelles Auftreten',
    'Gute Deutschkenntnisse, Englisch von Vorteil',
    'Flexibilität und Zuverlässigkeit',
    'Teamfähigkeit und Kommunikationsstärke',
  ];

  return (
    <>
      <SEO 
        title="Karriere"
        description="Werden Sie Teil des ConciergeUnit Teams. Wir suchen engagierte Mitarbeiter für Night-Audit, Empfang und Event-Service."
        path="/jobs"
      />

      {/* Hero Section */}
      <section className="pt-32 pb-20 bg-brand-950">
        <div className="container-custom">
          <div className="max-w-4xl">
            <span className="inline-block px-4 py-2 bg-platin-500/20 text-platin-300 text-sm font-medium rounded-full mb-6">
              Wir stellen ein
            </span>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">
              Gestalten Sie mit uns die Zukunft der Hotellerie
            </h1>
            <p className="text-xl text-platin-200 leading-relaxed mb-8 max-w-2xl">
              ConciergeUnit ist mehr als ein Arbeitgeber. Wir sind ein Team von 
              Passionisten, die die Hotellerie neu definieren. Wenn Sie Excellence 
              im Service lieben, sind Sie bei uns richtig.
            </p>
            <div className="flex flex-wrap items-center gap-6 text-platin-300">
              <div className="flex items-center gap-2">
                <MapPin className="w-5 h-5" />
                <span>Düsseldorf & bundesweit</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Why Join Us */}
      <section className="section-padding bg-white">
        <div className="container-custom">
          <div className="text-center max-w-3xl mx-auto mb-16">
            <span className="text-brand-600 font-semibold text-sm uppercase tracking-widest">
              Warum ConciergeUnit
            </span>
            <h2 className="heading-md text-brand-950 mt-3 mb-4">
              Ihre Vorteile bei uns
            </h2>
            <p className="text-gray-600 text-lg">
              Wir investieren in unsere Mitarbeiter. Denn wir wissen: 
              Zufriedene Teams liefern herausragende Ergebnisse.
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {benefits.map((benefit, index) => (
              <div 
                key={index}
                className="card-luxury p-8 text-center group"
              >
                <div className="w-16 h-16 rounded-2xl bg-brand-950 flex items-center justify-center mx-auto mb-6 group-hover:bg-platin-200 transition-colors duration-300">
                  <benefit.icon className="w-8 h-8 text-platin-200 group-hover:text-brand-950 transition-colors" />
                </div>
                <h3 className="text-xl font-bold text-brand-950 mb-2">
                  {benefit.title}
                </h3>
                <p className="text-gray-600">
                  {benefit.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Roles Section */}
      <section className="section-padding bg-platin-50">
        <div className="container-custom">
          <div className="grid lg:grid-cols-2 gap-16 items-center">
            <div>
              <span className="text-brand-600 font-semibold text-sm uppercase tracking-widest">
                Positionen
              </span>
              <h2 className="heading-md text-brand-950 mt-3 mb-6">
                In diesen Bereichen suchen wir Unterstützung
              </h2>
              <p className="text-gray-600 text-lg mb-8">
                Ob Berufseinsteiger oder erfahrener Profi – wir bieten Ihnen die 
                passende Position. Arbeiten Sie in renommierten Hotels und bei 
                exklusiven Events.
              </p>

              <div className="space-y-4">
                {roles.map((role, index) => (
                  <div 
                    key={index}
                    className="flex gap-4 p-5 bg-white rounded-xl border border-platin-200 hover:border-platin-400 transition-colors"
                  >
                    <div className="w-14 h-14 bg-brand-950 rounded-xl flex items-center justify-center shrink-0">
                      <role.icon className="w-7 h-7 text-platin-200" />
                    </div>
                    <div>
                      <h3 className="font-bold text-brand-950 text-lg">{role.title}</h3>
                      <p className="text-gray-600">{role.description}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="bg-brand-950 rounded-2xl p-8 lg:p-12">
              <h3 className="text-2xl font-bold text-white mb-6">
                Das bringen Sie mit
              </h3>
              <ul className="space-y-4">
                {requirements.map((req, index) => (
                  <li key={index} className="flex items-start gap-3 text-platin-200">
                    <Check className="w-5 h-5 text-platin-400 shrink-0 mt-0.5" />
                    <span>{req}</span>
                  </li>
                ))}
              </ul>

              <div className="mt-8 pt-8 border-t border-white/20">
                <p className="text-platin-300 text-sm">
                  Sie haben Erfahrung mit Hotelsystemen wie Opera, SIHOT oder Protel? 
                  Das ist ein Plus, aber kein Muss.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="section-padding bg-white">
        <div className="container-custom">
          <div className="bg-gradient-to-br from-brand-950 to-brand-900 rounded-3xl p-8 md:p-16 text-center">
            <h2 className="heading-md text-white mb-4">
              Bereit für den nächsten Schritt?
            </h2>
            <p className="text-platin-200 text-lg max-w-2xl mx-auto mb-8">
              Wir freuen uns darauf, Sie kennenzulernen. Senden Sie uns Ihre Bewerbung 
              – wir melden uns innerhalb von 48 Stunden bei Ihnen.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button
                onClick={() => setShowApplication(true)}
                className="inline-flex items-center justify-center gap-2 bg-platin-200 text-brand-950 px-8 py-4 rounded-lg font-semibold hover:bg-white transition-colors"
              >
                Jetzt bewerben
                <ArrowRight className="w-5 h-5" />
              </button>
              <a
                href={`mailto:info@conciergeunit.de?subject=Bewerbung`}
                className="inline-flex items-center justify-center gap-2 border-2 border-platin-400/50 text-white px-8 py-4 rounded-lg font-semibold hover:bg-white/10 transition-colors"
              >
                Per E-Mail bewerben
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Application Modal */}
      {showApplication && (
        <div 
          className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm"
          role="dialog"
          aria-modal="true"
          aria-labelledby="apply-modal-title"
        >
          <div className="bg-white rounded-2xl shadow-2xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
            <div className="p-6 border-b border-platin-200 flex items-center justify-between">
              <div>
                <h3 id="apply-modal-title" className="font-semibold text-xl text-brand-950">
                  Bewerbung
                </h3>
                <p className="text-gray-500 text-sm">Wir freuen uns auf Ihre Bewerbung</p>
              </div>
              <button
                onClick={() => setShowApplication(false)}
                className="p-2 hover:bg-platin-100 rounded-lg transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-platin-400"
                aria-label="Schließen"
              >
                <X className="w-5 h-5 text-gray-500" />
              </button>
            </div>
            <div className="p-6">
              <JobApplicationForm
                jobId="general"
                jobTitle="Initiativbewerbung"
                onClose={() => setShowApplication(false)}
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
}
